import React from "react";
import PropTypes from "prop-types";
import {fontStyles, fontFamilies} from "../../services/lib/fonts";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NoSsr from "@material-ui/core/NoSsr";
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import FormatUnderlinedIcon from "@material-ui/icons/FormatUnderlined";
import StrikethroughSIcon from "@material-ui/icons/StrikethroughS";
import ShadowIcon from "../../../../icons/ShadowIcon";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

class FontStyle extends React.Component {
  static propTypes = {
    current: PropTypes.object,
    handleChange: PropTypes.func
  };
  state = {
    anchorEl: null
  };
  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  getIconForFontStyle(style) {
    switch (style) {
      case `fontWeight`:
        return <FormatBoldIcon />;
      case `fontStyle`:
        return <FormatItalicIcon />;
      case `underline`:
        return <FormatUnderlinedIcon />;
      case `linethrough`:
        return <StrikethroughSIcon />;
      case `shadow`:
        return <ShadowIcon />;
    }
    return void 0;
  }
  render() {
    const {current, handleChange} = this.props;
    const {anchorEl} = this.state;
    return (
      <div className="font-style">
        <NoSsr>
          <Tooltip title="Стиль">
            <IconButton
              aria-owns={anchorEl ? `font-style-menu` : void 0}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              <FormatItalicIcon />
              <ArrowDropDownIcon />
            </IconButton>
          </Tooltip>
          <Menu
            id="font-style-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {fontStyles.map(({style, setValue, resetValue, tooltip}) => {
              const active = setValue === current[style];
              const value = active ? resetValue : setValue;
              const disabled = !fontFamilies[current.fontFamily][style];
              return (
                <MenuItem
                  key={style}
                  onClick={() => {
                    handleChange(style, value)();
                    this.handleClose();
                  }}
                  selected={active}
                  disabled={disabled}
                >
                  {this.getIconForFontStyle(style)}
                  {tooltip}
                </MenuItem>
              );
            })}
          </Menu>
        </NoSsr>
      </div>
    );
  }
}

export default FontStyle;
